import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { NoteClient, NoteView, NoteViewPaginatedResultDto, SearchNotesParameters } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class NoteService {
    constructor(private readonly client: NoteClient) {}

    async search(parameters: SearchNotesParameters): Promise<NoteViewPaginatedResultDto> {
        return await lastValueFrom(this.client.noteSearch(parameters));
    }

    async getById(id: number): Promise<NoteView> {
        return await lastValueFrom(this.client.noteGetById(id));
    }

    async save(body: NoteView): Promise<NoteView> {
        return await lastValueFrom(this.client.noteSave(body));
    }

    async delete(id: number): Promise<void> {
        return await lastValueFrom(this.client.noteDelete(id));
    }
}
